<template>
	<div class="setter">
		<Selector
			:value="linkType"
			:optionList="linkTypeList"
			valueKey="id"
			class="setter__selector"
			@input="linkTypeChange"
		/>
		<input
			v-model="linkValue"
			:disabled="!linkValueRequired"
			type="text"
			:placeholder="
				linkValueRequired
					? '링크값를 입력해주세요.'
					: '링크값이 필요 없어요!'
			"
			class="setter__input"
		/>
		<input :value="link" type="text" readonly class="setter__link" />
		<div class="setter__bottom">
			<CheckboxList :checkboxList="activeIconList" v-model="activeIcon" />
			<button
				class="btn blue setter__button"
				v-text="'설정'"
				:disabled="!link || (linkValueRequired && !linkValue)"
				@click="setLink"
			/>
		</div>
	</div>
</template>
<script>
	import { mapState, mapGetters } from 'vuex';
	import { isLinkValueRequired } from '@/util.js';
	import Selector from '@/components/Selector.vue';
	import CheckboxList from '@/components/CheckboxList.vue';

	export default {
		name: 'SetLink',
		components: {
			Selector,
			CheckboxList,
		},
		data() {
			const activeIconList = [{ id: true, value: '링크아이콘 노출' }];

			return {
				linkType: null,
				linkValue: '',
				activeIconList,
				activeIcon: [activeIconList[0].id],
			};
		},
		computed: {
			...mapState('modal', ['params']),
			...mapGetters({
				getListAddNull: 'getListAddNull',
			}),
			linkTypeList() {
				return this.getListAddNull('newLinkType');
			},
			linkValueRequired() {
				return this.linkType
					? isLinkValueRequired(this.linkType)
					: false;
			},
			link() {
				if (!this.linkType) return '';
				const linkValue = this.linkValue
					? `&value=${this.linkValue}`
					: '';
				return `glowpick://glowpick.com?type=${this.linkType}${linkValue}`;
			},
		},
		methods: {
			linkTypeChange(type) {
				this.linkType = type;
				this.linkValue = '';
			},
			setLink() {
				this.params.setLink(this.link, !!this.activeIcon.length);
				this.$store.commit('modal/toggleModal', false);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.setter {
		display: flex;
		width: 100%;
		flex-wrap: wrap;
		justify-content: flex-end;

		&__selector {
			display: block;
			width: 50%;
			flex-shrink: 0;
		}

		&__input {
			display: block;
			width: 50% !important;
			flex-shrink: 0;
			border-radius: 0 !important;
		}

		&__link {
			margin-top: 12px;
			border-radius: 0 !important;
		}

		&__bottom {
			display: flex;
			margin-top: 12px;
			align-items: center;
		}

		&__button {
			margin-left: 12px;

			&:disabled {
				cursor: not-allowed;
			}
		}
	}
</style>
